import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    appBar: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    link: {
        margin: theme.spacing(1, 1.5),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    statsContent: {
        padding: theme.spacing(12),
        textAlign: 'center',
    },
    signupContainer: {
        textAlign: 'center',
        marginTop: theme.spacing(6),
        padding: theme.spacing(6),
        backgroundColor: theme.palette.grey[200],
        marginBottom: theme.spacing(6),
    },
    signupButtons: {
        marginTop: theme.spacing(3),
    },
}));
